import React, { useEffect, useState } from "react";
import { Download, Smartphone } from "lucide-react";
import { APK_URL, APK_FILENAME } from "@/lib/constants";
import localApi, { LOCAL_API } from "@/lib/localApi";

/**
 * Download button for the Android APK.
 * Prefers the APK published via the App Release Manager (this backend);
 * falls back to the bundled CDN APK if none has been uploaded yet.
 */
export default function DownloadApp({ variant = "primary", className = "", label = "Download Android app", testid = "download-app-btn" }) {
  const [href, setHref] = useState(APK_URL);

  useEffect(() => {
    let alive = true;
    localApi
      .get("/app/version")
      .then(({ data }) => {
        if (alive && data?.exists) setHref(`${LOCAL_API}/app/download`);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const base = "group inline-flex items-center gap-2.5 rounded-full font-semibold px-7 py-4 transition-colors";
  const styles = {
    primary: "bg-primary text-primary-foreground hover:bg-primary/90",
    light: "bg-background text-foreground hover:bg-background/90",
    outline: "border border-foreground/20 hover:border-primary hover:text-primary",
  };
  return (
    <a
      href={href}
      download={APK_FILENAME}
      data-testid={testid}
      className={`${base} ${styles[variant] || styles.primary} ${className}`}
    >
      <Smartphone className="w-4 h-4" />
      <span>{label}</span>
      <Download className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" />
    </a>
  );
}
